export class TrainingRequirement {
    trainingItemType!: string;
    trainingItemId!: string;
    documentVersionNumber? : number | null;
}
